import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const WaiverInput = () => {
  const { waiverId = '', invoiceId } = useParams();
  const decodedId = waiverId ? atob(waiverId) : waiverId;
  const id = decodedId.replace(/\D/g, ''); 
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [invoice, setInvoices] = useState({});

  const route = 'waiver';

  useEffect(() => {
    if (waiverId) {
      setIsEditing(true);

      fetchWaiverDetails();
    }

    fetchInvoiceDetails();
  }, [waiverId]);

  const fetchWaiverDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.waiver}${id}/`, { headers });
      const waiverDetails = response.data;
      setFormData(waiverDetails);
    } catch (error) {
      console.error('Error fetching waiver details:', error);
    }
  };

  const fetchInvoiceDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.invoice}${invoiceId}/`, { headers });
      const invoiceDetails = response.data;
      setInvoices(invoiceDetails);
    } catch (error) {
      console.error('Error fetching invoice details:', error);
    }
  };

  const waiverFields = [
    {
      name: 'invoice',
      type: 'hidden',
      value: invoiceId,
    },
    {
      name: 'invoice_number',
      label: 'Invoice Number',
      type: 'text',
      readOnly: true,
      value: invoice.invoice_number,
    },
    {
      name: 'amount',
      label: 'Amount',
      type: 'number',
      value: '0',
    },
    {
      name: 'reason',
      label: 'Reason',
      type: 'textarea',
    },
    {
      name: 'approved_date',
      label: 'Approved Date',
      type: 'date',
    },
   
    // {
    //   name: 'approved_by',
    //   label: 'Approved By',
    //   type: 'select',
    //   options: [
    //     { value: 'Admin', label: 'Admin' },
    //     { value: 'Manager', label: 'Manager' },
    //     { value: 'User', label: 'User' },
    //   ],
    // },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Waiver' : 'Create Waiver'}</h1>
      <FormComponent
        fields={waiverFields}
        initialFormData={formData}
        route={route}
      />
    </div>
  );
};

export default WaiverInput;